import AxiosConfig from '@/config/axios-config'

export const VideosAPI = {

  listarVideosNovos () {
    return AxiosConfig.secureJalekoAPI().get('/videos/novos').then(response => response.data)
  },

  listarVideosIndicados () {
    return AxiosConfig.secureJalekoAPI().get('/videos/indicados').then(response => response.data)
  },

  listarVideosFavoritos () {
    return AxiosConfig.secureJalekoAPI().get('/videos/favoritos').then(response => response.data)
  },

  atualizarTempoVideo (ementaId, tempo) {
    return AxiosConfig.secureJalekoAPI().put(`/video/${ementaId}/atualizar-parada`, { tempo_de_parada: tempo, empresa_id: 1 }).then(response => response.data)
  }

}

export default VideosAPI
